import { Interpolation, Theme, css } from '@emotion/react'

export const wrapper: Interpolation<Theme> = (theme) => css`
  width: 100%;
  display: flex;
  gap: 10px;
  padding: 12px;
  border-radius: 12px;
  background-color: ${theme.colors.backgroundFive};
`

export const detail = css`
  flex: 1;
  display: flex;
  gap: 5px;
  justify-content: start;
`

export const name: Interpolation<Theme> = (theme) => css`
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  color: ${theme.colors.typographyTwo};
`

export const value: Interpolation<Theme> = (theme) => css`
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  color: ${theme.colors.typographyTwo};
`
